import { createContext, useContext } from 'react';
import {
  TableStore,
  TableStoreProps,
} from '@/components/table/contexts/tableStore.ts';
import { useStore } from 'zustand';

export const TableStoreContext = createContext<TableStore | null>(null);

export const useTableStoreContext = <T,>(
  selector: (state: TableStoreProps) => T,
): T => {
  const store = useContext(TableStoreContext);
  if (!store) {
    throw new Error('Missing TableStoreContext.Provider');
  }
  return useStore(store, selector);
};
